import PropTypes from "prop-types";
import { CountryIsoCode } from "v2/domain/common/enums/CountryISOCode";
import {
  MexicoBenefitRequest,
  PortugalBenefitRequest,
  SpainBenefitRequest,
} from "./components/BenefitRequestByCountry";

const BenefitRequests = ({ companyId, country, benefitsV2 }) => {
  if (country === CountryIsoCode.SPAIN) {
    return (
      <SpainBenefitRequest companyId={companyId} benefitsV2={benefitsV2} />
    );
  }

  if (country === CountryIsoCode.MEXICO) {
    return <MexicoBenefitRequest />;
  }

  if (country === CountryIsoCode.PORTUGAL) {
    return <PortugalBenefitRequest companyId={companyId} />;
  }

  return null;
};

BenefitRequests.propTypes = {
  benefitsV2: PropTypes.arrayOf(PropTypes.object).isRequired,
  country: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
};

export default BenefitRequests;
